import { StringIndexedObject } from "@kanda-libs/ks-design-library";
import { Order, Sorting } from "./types";

export const LABEL = "label";
export const PROVIDER = "provider";
export const APR = "apr";
export const FEE = "fee";
export const APR_TYPE = "apr_type";

const SHARED_TABLE_COLUMN_ATTRIBUTES = {
  width: 100,
  maxWidth: 2000,
};

const getSortingItems = (sorting: Sorting) => [
  {
    action: {
      type: `${sorting}-ascending`,
    },
    icon: "sort-ascending",
    name: "Sort Ascending",
  },
  {
    action: {
      type: `${sorting}-descending`,
    },
    icon: "sort-descending",
    name: "Sort Descending",
  },
];

export const TABLE_COLUMNS = [
  {
    id: PROVIDER,
    Header: "Provider",
    accessor: PROVIDER,
    subAccessors: [PROVIDER],
    items: getSortingItems(PROVIDER),
    ...SHARED_TABLE_COLUMN_ATTRIBUTES,
  },
  {
    id: LABEL,
    Header: "Label",
    accessor: LABEL,
    subAccessors: [LABEL],
    items: getSortingItems(LABEL),
    ...SHARED_TABLE_COLUMN_ATTRIBUTES,
  },
  {
    id: APR,
    Header: "APR",
    accessor: APR,
    subAccessors: [APR],
    items: getSortingItems(APR),
    ...SHARED_TABLE_COLUMN_ATTRIBUTES,
  },
  {
    id: FEE,
    Header: "Fee",
    accessor: FEE,
    subAccessors: [FEE],
    items: getSortingItems(FEE),
    ...SHARED_TABLE_COLUMN_ATTRIBUTES,
  },
  {
    id: APR_TYPE,
    Header: "Apr Type",
    accessor: APR_TYPE,
    subAccessors: [APR_TYPE],
    items: getSortingItems(APR_TYPE),
    ...SHARED_TABLE_COLUMN_ATTRIBUTES,
  },
];

export const DEFAULT_COLUMN = {
  minWidth: 80,
  width: 200,
  maxWidth: 400,
};

export const ORDER: StringIndexedObject<Order> = {
  NORMAL: "NORMAL",
  INVERSE: "INVERSE",
};
